import {InfoIcon} from '@uwm/ui';

interface InfoButtonProps {
    label?: string;
    onClick: () => void;
}

const InfoButton = ({label, onClick}: InfoButtonProps) => (
    <button
        type='button'
        aria-label={label}
        aria-haspopup='dialog'
        onClick={onClick}
        className='shrink-0 cursor-pointer'
    >
        <InfoIcon aria-hidden />
    </button>
);

export default InfoButton;
